import {
  createElementBlock as _createElementBlock,
  createElementVNode as _createElementVNode,
  openBlock as _openBlock
} from 'vue'

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      'svg',
      {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 24 24',
        width: '24',
        height: '24',
        fill: 'none',
        stroke: 'currentColor',
        'stroke-width': '1.5',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
      },
      [
        _createElementVNode('path', {
          d: 'm15 4-8 4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h3l8 4V4ZM7 8v8m-3 0 2 6h3l-2-6m12-8 2-1m-2 9 2 1m-2-5h3',
          fill: 'none'
        })
      ]
    )
  )
}
